// extracted by mini-css-extract-plugin
module.exports = {"desktopFx":"styles_desktopFx__njL_L","phoneUsageSearchFilters":"styles_phoneUsageSearchFilters__3HZMW"};